import React from 'react';
import { Container } from '../Container';
import { Label } from '../Label';
import { Reveal } from '../Reveal';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Discovery',
    desc: 'We get to know the person behind the profile — the audience, the ambition, and what is actually working.'
  }, {
    num: '02',
    title: 'Brand Strategy',
    desc: 'Positioning, voice, and a long-term identity that a brand deal can be built on.'
  }, {
    num: '03',
    title: 'Content & Growth',
    desc: 'A production rhythm that keeps output consistent and the audience compounding.'
  }, {
    num: '04',
    title: 'Partnerships & Deals',
    desc: 'We source, negotiate, and manage the partnerships worth saying yes to.'
  }];
  return <section className="border-b border-brand-gray300 py-[clamp(70px,10vw,140px)]" data-id="element-83" data-mp="158xgukar1f0m">
      <Container data-id="element-84" data-mp="109kwq7b9im1q">
        <div className="mb-[clamp(40px,6vw,80px)] flex flex-wrap items-end justify-between gap-[40px]" data-id="element-85" data-mp="10a30dp0982jo">
          <Label className="self-start" data-id="element-86" data-mp="2cfnby47ivvkq">03 · How it works</Label>
          <h2 className="max-w-[18ch] text-[clamp(2.2rem,5.6vw,5.2rem)] font-black leading-[0.95] tracking-[-0.025em]" data-id="element-87" data-mp="2hcvui5wl21mi">
            Four steps from creator to career.
          </h2>
        </div>

        <ol className="grid grid-cols-4 gap-px border-t border-brand-gray300 bg-brand-gray300 max-[900px]:grid-cols-2 max-[540px]:grid-cols-1" data-id="element-88" data-mp="2r3qh5bdqr38h">
          {steps.map((step, index) => <Reveal key={step.num} delay={index * 0.05} className="h-full" data-id="element-89" data-mp="303myerxswzti" data-mpi={index}>
              <li className="flex h-full flex-col bg-brand-white p-[clamp(28px,3vw,40px)_24px]" data-id="element-90" data-mp="305zmzny2e8fj">
                <span className="font-mono text-[12px] uppercase tracking-[0.18em] text-brand-gray600" data-id="element-91" data-mp="350wugqfp49qb">
                  {step.num}
                </span>
                <h3 className="mb-[14px] mt-[22px] text-[clamp(1.5rem,2.4vw,2.2rem)] font-black uppercase leading-none tracking-[-0.03em]" data-id="element-92" data-mp="1aq095tji3utk">
                  {step.title}
                </h3>
                <p className="text-[14px] leading-[1.5] text-[#2a2a2a]" data-id="element-93" data-mp="17mkgd564too5">
                  {step.desc}
                </p>
              </li>
            </Reveal>)}
        </ol>
      </Container>
    </section>;
}